import { Modal as ModalModule } from 'common';
import isFunction from 'lodash/isFunction';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;

const DeleteProductModal = ({
	data: { selectCount, onDeleteProductCallback },
	modalId,
}) => {
	const onDeleteButtonClick = closeModal => {
		if (isFunction(onDeleteProductCallback)) {
			onDeleteProductCallback();
		}

		closeModal();
	};

	const primaryButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Yes',
		onClick: onDeleteButtonClick,
		dataqa: 'delete-product-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-product-no-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="products delete-product-modal warning-modal"
			header="Delete Product"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>
					{selectCount > 1
						? `Delete ${selectCount} Products?`
						: `Delete this Product?`}
				</p>
			</div>
		</Modal>
	);
};

export default DeleteProductModal;
